import React, { useState, useEffect } from "react";
import BluetoothSetup from "./BluetoothSetup";
import { ConnectedProps, connect } from "react-redux";
import { ReducerState, WifiConnectArgs } from "../../types";
import { useGetDeviceByIdQuery } from "../../actions/devicesInQuery";
import { useBluetooth } from "./useBluetooth";
import { BLUETOOTH_STATES } from "./deviceProfiles";
import { displayErrorNotification } from "../../actions";

const mapStateToProps = (state: ReducerState) => {
  return {
    selected: state.devices?.selected?.uuid || null,
  };
};

const connector = connect(mapStateToProps, { displayErrorNotification });

type Props = ConnectedProps<typeof connector> & {};

const Index: React.FC<Props> = ({ selected, displayErrorNotification }) => {
  const handleSendErrorMessage = (msg: string) => {
    displayErrorNotification(msg);
  };

  const {
    connect,
    disconnect,
    connected,
    bluetoothState,
    scanWifi,
    startWifiConnect,
    isWifiConnected,
    currentNetwork,
  } = useBluetooth({ handleSendErrorMessage });

  const { data: selectedDevice } = useGetDeviceByIdQuery(selected!, {
    skip: !selected,
  });

  const [wifiList, setWifiList] = useState<string[]>([]);
  const [isConnecting, setIsConnecting] = useState(false);

  useEffect(() => {
    console.log(`currentNetwork: ${currentNetwork}`);
  }, [currentNetwork]);

  useEffect(() => {
    console.log(`Bluetooth State: ${bluetoothState}`);
  }, [bluetoothState]);

  useEffect(() => {
    console.log(`isWifiConnected: ${isWifiConnected}`);
  }, [isWifiConnected]);

  useEffect(() => {
    console.log(`connected: ${connected}`);
  }, [connected]);

  useEffect(() => {
    if (
      bluetoothState === BLUETOOTH_STATES.CONNECTED &&
      wifiList.length === 0 &&
      !isConnecting
    ) {
      setIsConnecting(true);
      setTimeout(async () => {
        const ssids = await scanWifi();
        setWifiList(ssids);
        setIsConnecting(false);
      }, 1000);
    }
  }, [
    bluetoothState,
    wifiList,
    setWifiList,
    scanWifi,
    isConnecting,
    setIsConnecting,
  ]);

  // actions
  const onScanButtonPressed = async () => {
    const success = await connect();
    if (!success) {
      displayErrorNotification(
        `Failed to connect to ${selectedDevice}. Please refresh the page and try again.`,
      );
    }
  };

  const onCancelButtonPressed = async () => {
    disconnect();
  };

  const onRescanButtonPressed = async () => {
    const ssids = await scanWifi();
    setWifiList(ssids);
  };

  const onConnectButtonPressed = async (values: WifiConnectArgs) => {
    startWifiConnect(values.ssid, values.psk);
  };

  return (
    <BluetoothSetup
      selectedDevice={selectedDevice}
      bluetoothState={bluetoothState}
      handleConnectButtonPressed={onConnectButtonPressed}
      handleScanButtonPressed={onScanButtonPressed}
      handleRescanWifiButtonPressed={onRescanButtonPressed}
      handleCancelButtonPressed={onCancelButtonPressed}
      wifiList={wifiList}
      currentNetwork={currentNetwork}
      isWifiConnected={isWifiConnected}
    />
  );
};

export default connector(Index);
